import React from "react";
import RitchText3 from "../Cities/RitchText3";

const ImaageLeft = (props) => {
  return (
    <>
      <div className="col-sm-6 right_col desktop_image">
        <img src={props?.item?.Image?.filename} className="img_banner" alt="" />
      </div>
      <div className="col-sm-6 left-section pr-0">
        <h2>{props?.item?.Heading}</h2>
        {/* <p className="block"> */}
          <RitchText3 Description={props?.item?.Description} />
        {/* </p> */}
      </div>
      <div className="col-sm-6 right_col mobile_image">
        <img src={props?.item?.Image?.filename} className="img_banner" alt="" />
      </div>
    </>
  );
};

export default ImaageLeft;
